import { BlockListRender, BlockRender, DMEData } from "dmeditor";
import styled from "@emotion/styled";
import { DME } from "dmeditor";
import { EntityBridgeCarousel, EntityBridgeCarouselChildren } from "./entity";

const Container = styled.div<{ mobileHeight?: number }>`
  .dme-viewmode-mobile & {
    overflow: hidden;
    ${(props) =>
      props.mobileHeight
        ? { "--bridge-carousel-height": props.mobileHeight + "px" }
        : { "--bridge-carousel-height": "70vh" }}
  }
`;

const BridgeCarousel = (
  props: DME.WidgetRenderProps<
    EntityBridgeCarousel,
    EntityBridgeCarouselChildren
  >
) => {
  const {
    blockNode: { children, data },
    mode,
    path,
    styleClasses,
  } = props;

  return children ? (
    <>
      <Container
        className={
          styleClasses["bridge-carousel"] || "bridge-carousel-carousel"
        }
        mobileHeight={data.settings?.heightMobile}
      >
        {children.carousel && (
          <BlockRender
            mode={mode}
            data={children.carousel as any}
            path={[...path, "carousel"]}
          />
        )}
      </Container>
      <div className="bridge-carousel-text">
        {children.text && (
          <BlockRender
            mode={mode}
            data={children.text as any}
            path={[...path, "text"]}
          />
        )}
      </div>
      <div className="bridge-carousel-buttons">
        {children.buttons && (
          <BlockRender
            mode={mode}
            data={children.buttons as any}
            path={[...path, "buttons"]}
          />
        )}
      </div>
    </>
  ) : (
    <></>
  );
};

export default BridgeCarousel;
